export default function getFileExt(file: File): string {
  const splits = file.name.split(".");
  return splits.length < 2 ? "" : splits[1];
}
